import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import axios from'axios'
import 'remixicon/fonts/remixicon.css'
import JSEncrypt from 'jsencrypt';
import * as loading from './utils/loading.js';

import preview from 'vue-photo-preview'	//图片预览组件
import 'vue-photo-preview/dist/skin.css'
import MetaInfo from 'vue-meta-info';
Vue.use(MetaInfo);

Vue.config.productionTip = false

let options = {
  maxSpreadZoom: 2, // 预览图最大的倍数，默认2倍
  fullscreenEl: false, //是否显示右上角全屏按钮
  closeEl: true, //是否显示右上角关闭按钮
  tapToClose: false, //点击滑动区域应关闭图库
  shareEl: false, //是否显示分享按钮
  zoomEl: true, //是否显示放大缩小按钮
  counterEl: false, //是否显示左上角图片数量按钮
  arrowEl: true,  //是否显示左右箭头（pc浏览器模拟手机时）
  tapToToggleControls: true, //点击应切换控件的可见性
  clickToCloseNonZoomable: false //点击图片应关闭图库，仅当图像小于视口的大小时
}
Vue.use(preview, options)

Vue.use(ElementUI);
//富文本编辑器
import 'font-awesome/css/font-awesome.css'
import VueHtml5Editor from 'vue-html5-editor'
Vue.use(VueHtml5Editor, {
    // 全局组件名称，使用new VueHtml5Editor(options)时该选项无效
    // global component name
    name: "vue-html5-editor",
    // 是否显示模块名称，开启的话会在工具栏的图标后台直接显示名称
    // if set true,will append module name to toolbar after icon
    showModuleName: false,
    // 自定义各个图标的class，默认使用的是font-awesome提供的图标
    // custom icon class of built-in modules,default using font-awesome
    icons: {
        text: "fa fa-pencil",
        color: "fa fa-paint-brush",
        font: "fa fa-font",
        align: "fa fa-align-justify",
        list: "fa fa-list",
        link: "fa fa-chain",
        unlink: "fa fa-chain-broken",
        tabulation: "fa fa-table",
        image: "fa fa-file-image-o",
        hr: "fa fa-minus",
        eraser: "fa fa-eraser",
        undo: "fa-undo fa",
        "full-screen": "fa fa-arrows-alt",
        info: "fa fa-info",
    },
    // 配置图片模块
    // config image module
    image: {
        // 文件最大体积，单位字节  max file size
        sizeLimit: 512 * 1024,
        // 上传参数,默认把图片转为base64而不上传
        // upload config,default null and convert image to base64
        upload: {
            url: null,
            headers: {},
            params: {},
            fieldName: {}
        },
        // 压缩参数,默认使用localResizeIMG进行压缩,设置为null禁止压缩
        // compression config,default resize image by localResizeIMG (https://github.com/think2011/localResizeIMG)
        // set null to disable compression
        compress: {
            width: 1600,
            height: 1600,
            quality: 80
        },
        // 响应数据处理,最终返回图片链接
        // handle response data，return image url
        uploadHandler(responseText){
            //default accept json data like  {ok:false,msg:"unexpected"} or {ok:true,data:"image url"}
            let json = JSON.parse(responseText)
            if (!json.ok) {
                alert(json.msg)
            } else {
                return json.data
            }
        }
    },
    // 语言，内建的有英文（en-us）和中文（zh-cn）
    //default en-us, en-us and zh-cn are built-in
    language: "zh-cn",
    // 自定义语言
    i18n: {
        //specify your language here
        "zh-cn": {
            "align": "对齐方式",
            "image": "图片",
            "list": "列表",
            "link": "链接",
            "unlink": "去除链接",
            "table": "表格",
            "font": "文字",
            "full screen": "全屏",
            "text": "排版",
            "eraser": "格式清除",
            "info": "关于",
            "color": "颜色",
            "please enter a url": "请输入地址",
            "create link": "创建链接",
            "bold": "加粗",
            "italic": "倾斜",
            "underline": "下划线",
            "strike through": "删除线",
            "subscript": "上标",
            "superscript": "下标",
            "heading": "标题",
            "font name": "字体",
            "font size": "文字大小",
            "left justify": "左对齐",
            "center justify": "居中",
            "right justify": "右对齐",
            "ordered list": "有序列表",
            "unordered list": "无序列表",
            "fore color": "前景色",
            "background color": "背景色",
            "row count": "行数",
            "column count": "列数",
            "save": "确定",
            "upload": "上传",
            "progress": "进度",
            "unknown": "未知",
            "please wait": "请稍等",
            "error": "错误",
            "abort": "中断",
            "reset": "重置"
        }
    },
    // 隐藏不想要显示出来的模块
    // the modules you don't want
    hiddenModules: [
      "full-screen",

    ],
    // 自定义要显示的模块，并控制顺序
    // keep only the modules you want and customize the order.
    // can be used with hiddenModules together
    visibleModules: [
        "text",
        "color",
        "font",
        "align",
        "list",
        "link",
        "unlink",
        "tabulation",
        "image",
        "video",
        "hr",
        "eraser",
        "undo",
    ],
    // 扩展模块，具体可以参考examples或查看源码
    // extended modules
    modules: [
    	//omit,reference to source code of build-in modules
    	{
    		name: 'video',
    		icon: 'el-icon-video-camera',
    		i18n: 'video',
    		show: true,
    		init: function (editor) {
    		},
    		//vue component
    		dashboard: {
    			template: '<div><el-tabs v-model="customForm.activeName"> <el-tab-pane label="添加视频链接" name="first"> <div style="margin-top:10px"> <el-input v-model="customForm.videoLink" placeholder="请输入视频链接" clearable /><el-button type="primary" size="small" style="margin: 20px 0px 0px 0px " @click="insertVideoLink(customForm.videoLink,null)">确认</el-button></div></el-tab-pane></el-tabs></div>',
    			data: function () {
    				return {
    					videoUrl: '',
    					customForm: {
    						videoLink: '',
    						activeName: 'first' //标签默认选择
    					},
    					buttonName: '上传视频',
    					typeFileVideo: 'video',
    					licenseUrlVideo: [],
    				}
    			},
    			methods: {
    				//上传视频-自定义-视频链接
    				insertVideoLink(videoLink, poster) {
    					if (!videoLink) {
    						this.$message.info('视频地址不能为空！')
    						return false;
    					}
    					this.$parent.execCommand('insertHTML', '<br><video class="ql-video video-width" src="' + videoLink + '" controls controlslist="nodownload" x5-video-player-type="h5" x5-video-orientation="portraint" x5-playsinline="true" x5-video-player-fullscreen="true" type="video/mp4">')
    					this.customForm.videoLink = ''
    				},
    				
    			}
    		}
    	}
    ]
})

Vue.prototype.$getRsaCode = function(str){ // 注册方法
  let pubKey='MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCqTC41im8cR82JvgrUuxCT8J2UrsOvXv+IAPCtRqAC4aTIRMZ/IQtv2NgmUnwSNGB4FiL13S50Jn8wS1x9H2mPb/blmwS/U97omkm/52UdBAp7jo5aVFtr2PIrJ7Mv5VRnrXhTz3uHLJSbti1AsijCjltR8Tg+cmSCZcdKXVbuQQIDAQAB';// ES6 模板字符串 引用 rsa 公钥
  let encryptStr = new JSEncrypt();
  encryptStr.setPublicKey(pubKey); // 设置 加密公钥
  let  data = encryptStr.encrypt(str.toString());  // 进行加密
  return data;
}

Vue.config.productionTip = false


axios.defaults.timeout = 30*60*1000;  //30分钟
if(process.env.NODE_ENV=='development')
{
  axios.defaults.baseURL= '/api';
}

axios.defaults.headers.post['Content-Type'] = "application/json";
axios.defaults.withCredentials = true;
//axios.defaults.headers.common['Authorization'] = store.state.token;

Vue.prototype.$ajax=axios;



// 添加请求拦截器
axios.interceptors.request.use(config => {
  // 在发送请求之前做些什么
  //判断是否存在token，如果存在将每个页面header都添加token
  //console.log('config:',config);
  //console.log(config.url);
  //showLoading();  //显示加载中
  if(store.state.token){
    config.headers.common['Authorization']=store.state.token;
    //console.log('tokenHeader:');
    //console.log(store.state.token);
  }

  return config;
}, error => {
// 对请求错误做些什么
  //hideLoading();
  return Promise.reject(error);
});


// http response 拦截器

// 是否正在刷新的标记
let isRefreshing = false;
// 重试队列，每一项将是一个待执行的函数形式
let requests = []

axios.interceptors.response.use(
  response => {
    //console.log(response.data);
    //hideLoading();
    if(response.data.desc){
      response.data.desc=response.data.desc.replace(/#10#13/g,'');
    }
    return response;

  },
  error => {
    //hideLoading();
    if (error.response) {
      switch (error.response.status) {
        case 401:
          const config = error.response.config;

          // 说明token过期了,刷新token
          if (!isRefreshing) {
            isRefreshing = true;

            //console.log('refreshing token:' + store.state.refreshToken);


              return refreshToken().then(res => {

                let errorCode=res.data.errorCode;
                if(errorCode=='0')
                {
                  // 刷新token成功，将最新的token更新到header中，同时保存在localStorage中
                  //console.log('refreshToken:',res.data);
                  const token = res.data.token;
                  const refreshToken = res.data.refreshToken;

                  store.commit('setToken',{token: token});
                  store.commit('setRefreshToken',{token: refreshToken});

                  // 获取当前失败的请求

                  // 重置一下配置
                  config.headers['Authorization'] = token;
                  //config.baseURL = '' // url已经带上了/api，避免出现/api/api的情况
                  // 重试当前请求并返回promise
                  // 已经刷新了token，将所有队列中的请求进行重试
                  requests.forEach(cb => cb(token));
                  // 重试完了别忘了清空这个队列（掘金评论区同学指点）
                  requests = [];
                  return axios(config);

                }
                else
                {

                  //console.error('refreshtoken errorCode =>', errorCode);
                  //未获取到token，跳转到首页重新登录吧
                  store.commit('delToken');
                  store.commit('delRefreshToken');
                  //console.log('errors');
                  router.replace({
                    path: '/login',
                    query: {redirect: router.currentRoute.fullPath}
                  });

                  //console.log('error' + router.currentRoute.fullPath);
                  //return false;

                }

            }).catch(res => {
              //console.error('refreshtoken error401 =>', res);
              //刷新token失败，神仙也救不了了，跳转到首页重新登录吧
              store.commit('delToken');
              store.commit('delRefreshToken');
              // router.replace({
              //   path: '/login',
              //   query: {redirect: router.currentRoute.fullPath}
              // });
              ElementUI.MessageBox('登录已过期，请重新登录。', '系统提示', {
                confirmButtonText: '确定',
                callback: action => {
                  router.replace({
                    path: '/login',
                    query: {redirect: router.currentRoute.fullPath}
                  });
                }
              });
              return false;
            }).finally(() => {
              isRefreshing = false;

              //console.log('refresh finally');
            })

          }
          else
          {
            // 正在刷新token，返回一个未执行resolve的promise
            return new Promise((resolve) => {
              // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
              requests.push((token) => {
                //config.baseURL = ''
                config.headers['Authorization'] = token
                resolve(axios(config))
              })
            })
          }
          break;
          //console.log(this.$store);
        case 504:
          let errorInfo='连接服务器失败。' + error.response.statusText + '(' + error.response.status + ')';

          Message.error(errorInfo);
          
          break;
        case 402:
          //console.log('402');
          store.commit('delToken');
          store.commit('delRefreshToken');

          //Message.error('用户在其他地方登录');
          //alert('用户在其他地方登录');
          ElementUI.MessageBox('用户在其他地方登录，你被迫下线。', '系统提示', {
            confirmButtonText: '确定',
            callback: action => {
              router.replace({
                path: '/login',
                query: {redirect: router.currentRoute.fullPath}
              });
            }
          });

          break;
      }
    }
    return Promise.reject(error.response)
  });
function refreshToken () {
    // instance是当前request.js中已创建的axios实例
    let refreshToken=store.state.refreshToken;

    let refresh={headers: {'Authorization': refreshToken}};
    return axios.post('/handler/Login/refreshToken.ashx',{},refresh).then(res => res);

}

router.beforeEach((to, from, next) => {
  //NProgress.start();
  //console.log('to:',to);
	
	if (to.path == '/login') {
		sessionStorage.removeItem('user');
	}
	
	let user=sessionStorage.getItem('user');
	//console.log('main.js',to);
	
	if ((user==null||user=='') && to.path != '/login' && to.path != '/' && to.path.indexOf('/search/')<0 && (to.path.indexOf('/view/')<0 || to.path.indexOf('/webdanglist/view/')>0)) {
		next({ path: '/login' });
	} else {
	
		next();
	}
	
	//console.log('store.state.closingPage', store.state.closingPage);
	
	if(store.state.closingPage.findIndex(item=>item==to.name)>=0)
	{
		to.meta.keepAlive=false;
	}
	else
	{
		to.meta.keepAlive=true;
	}
	
	if(to.path!='/login'&&to.path!='/404'&&to.path!='/' && to.path.indexOf('/search/')<0 && (to.path.indexOf('/view/')<0 || to.path.indexOf('/webdanglist/view/')>=0))
	{
		let title=to.meta.title;
		let toName=to.name;
		let fromName=from.name;
		//console.log(to,'toName:',toName,'fromName:',fromName);
	
		if(!!title && title.indexOf('—')>0){
			title=title.substring(0,title.indexOf('—'));
		}
		if(toName && toName.indexOf('—')>0){
			toName=toName.substring(0,toName.indexOf('—'));
		}
		if(to.params && to.params.type && to.params.type!=''){
			if(to.params.AutoID && to.params.AutoID!=''){
				toName=toName + '-' + to.params.type + '-' + to.params.AutoID;
			}
			else{
				toName=toName + '-' + to.params.type;
			}
		}
		//console.log('toName:',to.params.type);
	
		if(to.params && to.params.type=='new'){
			to.meta.title=title + '—新建';
			
			let ind = store.state.worktab.list.findIndex(s => s.name === toName);
			//console.log('main.js', ind, toName);
			if(ind>=0){
				to.meta.keepAlive = true;
			}
			else{
				to.meta.keepAlive = false;
			}
			
		}
		else if(to.params && to.params.type=='edit'){
			to.meta.title=title + '—编辑';
			//to.meta.keepAlive = false;
			store.dispatch('worktabRemoveNoBack', to.name + '-view-' + to.params.AutoID);
	
		}
		else if(to.params && to.params.type=='view'){
			to.meta.title=title + '—查看';
			//to.meta.keepAlive = false;
			store.dispatch('worktabRemoveNoBack', to.name + '-edit-' + to.params.AutoID);
		}
		//console.log('toName:',toName,'fromName:',fromName);
	
		store.dispatch('worktabRoute', {
			to: {
				name: toName ? toName : '',
				tabname: (to.meta && to.meta.title) ? to.meta.title : '',
				path: to.path
			},
			from: {
				name: fromName ? fromName : '',
				tabname: (from.meta && from.meta.title) ? from.meta.title : '',
				path: from.path
			}
		})
	}

  router.onError((error) => {
      const pattern = /Loading chunk (\d)+ failed/g;
      const isChunkLoadFailed = error.message.match(pattern);
      console.log(isChunkLoadFailed,'/Loading chunk (\d)+ failed/g','路由懒加载找不到对应的moudle',error)
      if (isChunkLoadFailed) {
          window.location.reload();
      }else{
          console.log(error)
      }
  });



  /*store.dispatch('worktabRoute', {
    to: {
      name: to.name ? to.name : '',
      tabname: (to.meta && to.meta.title) ? to.meta.title : '',
      path: to.path
    },
    from: {
      name: from.name ? from.name : '',
      tabname: (from.meta && from.meta.title) ? from.meta.title : '',
      path: from.path
    }
  })
  */
  return
})
//增加String 对象原型方法 replaceAll
String.prototype.replaceAll = function(s1,s2){
return this.replace(new RegExp(s1,"gm"),s2);
}

new Vue({
  router,
  store,
  render: h => h(App),
	// 关键步骤：实例挂载完成后触发事件
	mounted () {
		document.dispatchEvent(new Event('render-event'))
	}
}).$mount('#app')
